import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-upload-viewer',
  templateUrl: './upload-viewer.component.html',
  styleUrls: ['./upload-viewer.component.scss']
})
export class UploadViewerComponent {

  pdfUrl: SafeResourceUrl | null = null;

  readonly data = inject<any>(MAT_DIALOG_DATA);
  constructor(private dialogRef: MatDialogRef<UploadViewerComponent>) {}

  ngOnInit() {
    this.pdfUrl = this.data.pdfUrl;
  }

  onClose() {
    this.dialogRef.close();
  }
}
